export default __webpack_public_path__ + "static/media/keto_broken_heart.34875da9.svg";